import ConfirmationModal from 'components/common/ConfirmationMessage';
import { effectiveStatus } from 'helpers/effectiveStatus';
import { ListLayout } from 'components/common/ListLayout';
import { getBackgroundStyle, getEyeStyle } from 'components/common/TableColor';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { convertDateFormat } from 'helpers/convertDateFormat';
import { formatDuration } from 'helpers/formatDuration';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { InterpreterDashboardSelector } from 'slices/interpreter/dashboardSlice';
import { fetchInterpreterDashboardAppointments } from 'slices/interpreter/dashboardSlice';

const ListTable = ({ data, total, query, onQueryChange }) => {
    const dispatch = useDispatch();
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    // Page / page length / sort / search live in the parent's `query` object now. The sort
    // handler below used to send ONLY sortBy/sortDirection/search, throwing away the date range,
    // status, language and page size — the client's "sorted by date and old jobs came up".
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { last_page: totalPages, current_page, per_page: pageLength } = useSelector(InterpreterDashboardSelector);

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };
    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }
    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }
    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    //#region TABLE HEAD 
    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            onQueryChange({ sortBy, sortDirection: dir })
        }

        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="appid"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Service"
                        sortBy="type"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Date"
                        sortBy="datetime"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Duration"
                        sortBy="duration"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language_id"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="JobLocation"
                        sortBy="job_location_id"
                        sortDirection={query?.sortDirection}
                        activeSortBy={query?.sortBy}
                        callBack={callBack}
                    />
                </th>
                <th>Cases</th>
            </tr>
        )
    }, [selectAll, sortFields, query, selectedItems, onQueryChange]);
    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} />
            ))
        )
    }, [selectedItems, data]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        setActionAccept({
            show: true,
            item: { id },
        });
    }, [])

    const handleCloseActionButton = React.useCallback((id) => {
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])

    const handleDeclineShow = React.useCallback((id) => {
        setDeclineModal({
            show: true,
            item: { id },
        });
    }, [])


    return (
        <div className='mt-4'>
            <ListLayout
                heading={`dashboard appointments`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchInterpreterDashboardAppointments}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                query={query}
                onQueryChange={onQueryChange}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                noOfItems={total}
            >
                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}
            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, current_page, pageLength
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    // Colours come from components/common/TableColor — this file used to carry its own copies
    // that had drifted (no vendor_cancelled branch, so those rows rendered uncoloured).
    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(effectiveStatus(item))}>
                {/* {serial} */}
                <div className='eye_area' style={getEyeStyle(effectiveStatus(item))}>
                    <Link to={`/interpreter/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {item?.appid || '-'}
                {item?.cases?.some(c => c?.service_type === 'Document Translation') && (
                    <span
                        title="This job includes a Document Translation case"
                        style={{
                            display: 'inline-block',
                            marginTop: 4,
                            padding: '1px 8px',
                            fontSize: 11,
                            fontWeight: 600,
                            lineHeight: 1.6,
                            borderRadius: 10,
                            background: '#ffb82a',
                            color: '#5a3d00',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        📄 Doc Translation
                    </span>
                )}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))} className='text-transform-capitalize '>
                {effectiveStatus(item) || '-'}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {item?.appointment_details?.job_location?.by_zoom ? 'Zoom' : 'In Person'}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {convertDateFormat(item?.datetime) || '-'}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {formatDuration(item?.duration)}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {item?.language?.name || '-'}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {item?.appointment_details?.job_location?.name || '-'}
            </td>
            <td style={getBackgroundStyle(effectiveStatus(item))}>
                {item?.cases?.length > 0
                    ? item.cases.map(c => c.case_number).filter(Boolean).join(', ')
                    : '-'}
            </td>
        </tr>
    )
})
export default ListTable